/* eslint-disable eqeqeq */
import React, { useRef, useEffect, useCallback } from 'react'
import { Link } from 'react-router-dom'
import FormSearch from './components/FormSearch.jsx'
import CommonTable from '@/components/commonTable'
import moment from 'moment'
import { _realtimeShareDetailList } from '@/statics/js/api'
import queryString from 'query-string'

const columns = [
  {
    title: '分润类型',
    dataIndex: 'transferTypeName',
    width: 120
  },
  {
    title: '代理商',
    dataIndex: 'agentName',
    width: 120
  },
  {
    title: '站点',
    dataIndex: 'siteName',
    width: 120
  },
  {
    title: '套餐名',
    dataIndex: 'packageName',
    width: 120
  },
  {
    title: '套餐金额',
    dataIndex: 'packageAmount',
    width: 120
  },
  {
    title: '订单编号',
    width: 180,
    dataIndex: 'orderSn',
    render: (text) => (
      <Link target='_blank' to={'/packageOrderManagement?orderSn=' + text}>
        {text}
      </Link>
    )
  },
  {
    title: '订单金额',
    dataIndex: 'orderAmount',
    width: 100,
    align: 'center'
  },
  {
    title: '支付流水号',
    dataIndex: 'payTradeNo',
    width: 190
  },
  {
    title: '支付金额',
    dataIndex: 'payAmount',
    width: 100,
    align: 'center'
  },
  {
    title: '支付方式',
    dataIndex: 'payTypeName',
    width: 100
  },
  {
    title: '转账流水号',
    dataIndex: 'tradeNo',
    width: 150
  },
  {
    title: '需转账金额',
    dataIndex: 'transferAmount',
    width: 110,
    align: 'center'
  },
  {
    title: '已转账金额',
    dataIndex: 'realAmount',
    width: 110,
    align: 'center'
  },
  {
    title: '转账时间',
    dataIndex: 'addTime',
    width: 150,
    render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-')
  },
  {
    title: '收款账号',
    dataIndex: 'transferAccount',
    width: 160
  },
  localStorage.getItem('type') != 1 && localStorage.getItem('type') != 8
    ? {
        title: '付款主体',
        dataIndex: 'paymentAccount',
        width: 160
      }
    : {}
]

const RealtimeShareDetail = (props) => {
  const tableRef = useRef()

  useEffect(() => {
    // 默认筛选最近一个月，比如2025-06-05 到 2025-07-05  timeEnd是当天 timeStart是往前一个月
    const timeStart = moment().subtract(1, 'month').format('YYYY-MM-DD')
    const timeEnd = moment().format('YYYY-MM-DD')
    const transferTime = [timeStart, timeEnd]
    // url query参数 orderSn 筛选全部移除默认日期
    const { orderSn, payTradeNo } = queryString.parse(props.location.search)
    const params = {
      orderSn,
      payTradeNo,
      transferTime: payTradeNo ? undefined : transferTime
    }
    handleSearch(params)
  }, [])

  const handleSearch = async (params) => {
    const { transferTime } = params
    let searchParams = { ...params }
    if (transferTime && transferTime.length) {
      searchParams.startDateStr = formatDate(transferTime[0])
      searchParams.endDateStr = formatDate(transferTime[1])
    } else {
      searchParams.startDateStr = undefined
      searchParams.endDateStr = undefined
    }
    delete searchParams.transferTime
    await tableRef.current.handleSearch(searchParams)
  }

  const formatDate = useCallback((time) => {
    return time ? moment(time).format('YYYY-MM-DD') : undefined
  }, [])

  return (
    <>
      <div>
        <div className='select-form'>
          <FormSearch search={handleSearch} formatDate={formatDate} location={props.location} />
        </div>
        <CommonTable
          ref={tableRef}
          auto={false}
          showSort
          action={_realtimeShareDetailList}
          options={{
            columns: columns,
            scroll: { x: 1400 }
          }}
          params={{}}
        />
      </div>
    </>
  )
}

export default RealtimeShareDetail
